/*global FB*/

<template>
  <div class="container">

    <nav class="navbar navbar-expand-sm bg-dark navbar-dark my-4">
      <ul class="navbar-nav">
        <li class="nav-item active">
          <a class="nav-link" href="#">エントリーシート評価</a>
        </li>
      </ul>
    </nav>

    <div>
      <fb-signin-button
        :params="fbSignInParams"
        @success="onSignInSuccess"
        @error="onSignInError">
        Facebookでログイン
      </fb-signin-button>
      <p>{{ name }}</p>
      <p>{{ email }}</p>
    </div>

    <div class="row">
      <div class="form-group col-12">
        <textarea id="area" class="form-control" style="height:40vh;" v-model="text"></textarea>

        <input v-show="!isQuerying" type="submit" v-on:click="goQuery" class="btn btn-primary my-3 w-100" value="分析する">
      </div>
    </div>

    <ScaleLoader  v-show="isQuerying" :loading="isQuerying" :color="color" :height="height" :width="width"></ScaleLoader>

    <div v-show="word_count_message" class="card bg-warning my-5">
      <p class="catd-text">{{ word_count_message }}</p>
    </div>

    <div v-show="gotResult">
      <IndustrySelector></IndustrySelector>
      <ResultCard :title="'Personality'" :datasets="personalityList" ></ResultCard>
      <ResultCard :title="'Needs'" :datasets="needsList"></ResultCard>
      <ResultCard :title="'Values'" :datasets="valuesList"></ResultCard>
    </div>
 </div>

</template>

<style scoped>
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #4267b2;
  color: #fff;
}
</style>

<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import ResultCard from './ResultCard'
import IndustrySelector from './IndustrySelector'
import Multiselect from 'vue-multiselect'

export default {
  name: 'HelloWorld',
  data () {
    const HERE = `【職務概要】
食品会社の営業職として6年間勤務し、その後総務課に異動になって現在に至ります。総務職として社内規定管理（就業規則等）、車両管理、庶務業務、株式業務等に携わってきました。
車両管理では、使用ルール、所有する車両の買い替え時期、車種等の規定を作成し、事務の簡素化を行い経費の削減に努めました。株式業務では、召集通知、議決権行使書の集計、会場設営、議事録の作成等に関して、リーダーとして業務を取りまとめました。

【総務としての強み】
・営業経験があり、対外的な折衝や交渉業務をスムーズに行えます。
・管理業務では、マニュアルを用いた業務フローの統一を実践できます。
・PCや規定を整備することで、余分な備品を削減し経費節減ができます。
・後方部門として円滑なサポート実現のために、役職に囚われない業務連携を目指します。
・前職における課長補佐としての業務経験を生かします。

【志望動機】
管理職にこだわるわけではありませんが、総務としてより自分を向上させたいと考えていたところ、貴社の求人を拝見しました。今まで培った総務としての実務能力、マネジメント能力を発揮して、貴社で貢献したいと考え志望しました。特に、営業主体という貴社業態は前職と共通する部分も多く、短期間で戦力として貢献できると確信します。

【仕事の姿勢】
転職にあたり、前職の経験を生かすと共に新たな気持ちでチャレンジしていきます。「いかなる時ももう一歩」が私の仕事における信条です。何事も妥協せず、今やるべきことはすぐに行動に移し、常に「もう一歩」高い成果を求めて業務を行います。営業経験がありますので、新しい環境でも良好な人間関係を構築することが得意です。企業が変われば社内のルールや業務内容も異なりますが、必要な知識やスキルは自主的に習得し、短期間で戦力になるよう頑張ります。`

    return {
      fbSignInParams: {
        scope: 'email',
        return_scopes: true
      },
      gotResult: false,
      isQuerying: false,
      color: '#00cec9',
      width: '3px',
      height: '20px',
      text: HERE,
      value: [],
      name: '',
      email: ''
    }
  },
  computed: {
    options () {
      return this.$store.getters['graphDatasets/entries']
    },
    personalityList () {
      const person = this.$store.getters['graphDatasets/person']
      const industry = this.$store.getters['graphDatasets/industry']
      return [person.personality, industry.personality]
    },
    needsList () {
      const person = this.$store.getters['graphDatasets/person']
      const industry = this.$store.getters['graphDatasets/industry']
      return [person.needs, industry.needs]
    },
    valuesList () {
      const person = this.$store.getters['graphDatasets/person']
      const industry = this.$store.getters['graphDatasets/industry']
      return [person.values, industry.values]
    },
    word_count_message () {
      return this.$store.getters['graphDatasets/word_count_message']
    }
  },
  methods: {
    goQuery () {
      this.isQuerying = true
      this.$store.dispatch('graphDatasets/evaluate', this.text).then(() => {
        this.isQuerying = false
        this.gotResult = true
      }).catch(() => {
        this.isQuerying = false
      })
    },
    onSignInSuccess (response) {
      console.dir(response)
      FB.api('/me?fields=email,name', dude => {
        console.dir(dude)
        console.log(`Good to see you, ${dude.name}.`)
        this.name = dude.name
        this.email = dude.email
      })
    },
    onSignInError (error) {
      console.log('OH NOES', error)
    }
  },
  mounted () {
  },
  components: {
    ResultCard,
    IndustrySelector,
    ScaleLoader,
    Multiselect
  }
}

// FB.login(function (response) {

//   // Check if the user logged in successfully.
//   if (response.authResponse) {

//     console.log('You are now logged in.');

//     // Add the Facebook access token to the Cognito credentials login map.
//     AWS.config.credentials = new AWS.CognitoIdentityCredentials({
//       IdentityPoolId: 'IDENTITY_POOL_ID',
//       Logins: {
//         'graph.facebook.com': response.authResponse.accessToken
//       }
//     });

//     // Obtain AWS credentials
//     AWS.config.credentials.get(function(){
//         // Access AWS resources here.
//     });

//   } else {
//     console.log('There was a problem logging you in.');
//   }

// });

</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue